import types from './types'

export const initialState = {
  trainingData: {},
  trainingCompletionData: {},
  error: null,
  isFetching: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_TRAINING_ATTEMPTS:
    case types.FETCH_TRAINING_ATTEMPTS_ERROR:
    case types.FETCH_TRAINING_ATTEMPTS_SUCCESS:
      return {
        ...state,
        error:
          action.type === types.FETCH_TRAINING_ATTEMPTS_ERROR
            ? action.error
            : null,
        isFetching: action.type === types.FETCH_TRAINING_ATTEMPTS,
        trainingData:
          action.type === types.FETCH_TRAINING_ATTEMPTS_SUCCESS
            ? {
                ...state.trainingData,
                [`${action.siteId}.${action.licenseId}.${action.program}`]: action.trainingData,
              }
            : state.trainingData,
      }

    case types.FETCH_TRAINING_COMPLETION:
    case types.FETCH_TRAINING_COMPLETION_ERROR:
    case types.FETCH_TRAINING_COMPLETION_SUCCESS:
      return {
        ...state,
        error:
          action.type === types.FETCH_TRAINING_COMPLETION_ERROR
            ? action.error
            : null,
        isFetching: action.type === types.FETCH_TRAINING_COMPLETION,
        trainingCompletionData:
          action.type === types.FETCH_TRAINING_COMPLETION_SUCCESS
            ? {
                ...state.trainingCompletionData,
                [action.siteId]: action.completionData,
              }
            : state.trainingCompletionData,
      }

    default:
      return state
  }
}
